<template>
  <default-grid :show-right-container="false" :show-left-container="false">
    <template v-slot:main-container>
      <div class="settings-page delete-account-page">
        <div v-if="!xsOnly" class="settings-vector">
          <img src="@/assets/images/promohunter_vecor.png" alt="">
        </div>
        <div class="settings-card">
          <router-localized-link :to="{name: 'settings'}">
            <span class="settings-page-close icon-close-4"></span>
          </router-localized-link>

          <img class="settings-icon" src="@/assets/images/settings.svg" alt="">
          <div class="settings-header">
            <span v-t="'menu.user_settings.delete_account.header'"/>
          </div>
          <div class="settings-header-2 mb-3">
            <span v-t="'menu.user_settings.delete_account.header_2'"/>
          </div>
          <div class="deletion-form">
            <el-form
                :model="form"
                ref="form"
                :rules="rules"
                label-position="left"
            >
              <div class="my-2">
                <el-checkbox
                    v-model="cancelCheckbox"
                    class="big"
                    :label="$t('menu.user_settings.delete_account.cancel_checkbox')"
                />
              </div>

              <div class="my-2">
                <el-checkbox
                    v-model="confirmCheckbox"
                    class="big"
                    :label="$t('menu.user_settings.delete_account.confirm_checkbox')"
                />
              </div>
              <template v-if="confirmCheckbox">
                <div class="my-2">
                  <el-select
                      v-model="reasonSelect"
                      class="rounded-select reason-select"
                      :placeholder="$t('menu.user_settings.delete_account.reason')"
                      :disabled="!confirmCheckbox"
                  >
                    <el-option
                        v-for="(reason, key) in reasonsList"
                        :key="key"
                        :label="reason"
                        :value="key"
                    />
                  </el-select>
                </div>
                <div class="my-2">
                  <el-input
                      class="rounded-input"
                      v-if="reasonSelect === 'other'"
                      v-model="reason"
                      :placeholder="$t('menu.user_settings.delete_account.reason')"
                  />
                </div>
                <div class="my-2">
                  <span v-t="'menu.user_settings.delete_account.confirm_deletion_text'"/>
                </div>
                <div class="my-2">
                  <el-form-item prop="delete_confirmation">
                    <el-input
                        class="rounded-input"
                        v-model="form.delete_confirmation"
                        :placeholder="$t('menu.user_settings.delete_account.confirm_placeholder')"
                    />
                  </el-form-item>
                </div>
              </template>

              <div class="mt-4">
                <el-button type="primary"
                           class="w-100"
                           @click="submitDeletion">
                  <span v-t="'menu.user_settings.delete_account.confirm_button'"/>
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </template>
  </default-grid>
</template>

<script>
import DefaultGrid from '@/views/DefaultGrid';
import RouterLocalizedLink from '@/components/common/RouterLocalizedLink';
import store from '@/store';
import {mapActions} from 'vuex';

export default {
  name: 'DeleteAccountView',
  components: {
    DefaultGrid,
    RouterLocalizedLink
  },
  data() {
    return {
      reasonsList: {},
      reasonSelect: null,
      reason: '',
      confirmCheckbox: false,
      cancelCheckbox: false,
      form: {
        delete_confirmation: '',
      },
      rules: {
        delete_confirmation: [
          {
            validator(rule, value, callback) {
              if (value !== 'DELETE') {
                callback(new Error(store.getters['auth/I18N'].t('menu.user_settings.delete_account.wrong_confirmation')))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
      }
    }
  },
  mounted() {
    this.reasonsList = store.getters['auth/I18N'].tm('menu.user_settings.delete_account.reasons_list');
  },
  methods: {
    ...mapActions('auth', [
      'DELETE_USER',
    ]),

    submitDeletion() {
      if (!this.confirmCheckbox) {
        return this.routerPush({name: 'settings'});
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.DELETE_USER({reason: this.reason});

          return true;
        }
        return false;
      });
    }
  },
  watch: {
    confirmCheckbox(value) {
      if (value) {
        this.cancelCheckbox = false;
      }
    },
    cancelCheckbox(value) {
      if (value) {
        this.confirmCheckbox = false;
      }
    },
    reasonSelect(value) {
      if (value !== 'other') {
        this.reason = this.$i18n.tm('menu.user_settings.delete_account.reasons_list')[value];
      } else {
        this.reason = '';
      }
    }
  },
}
</script>
